import { isNumber } from 'lodash'

export const divideIfNotZero = (numerator: number, denominator: number) => {
  return denominator === 0 || isNaN(denominator) ? 0 : numerator / denominator
}

export function getWindDirection (value: number) {
  if (isNumber(value)) {
    if (value > 350 || value <= 10) return 'N'
    if (value > 10 && value <= 80) return 'NE'
    if (value > 80 && value <= 100) return 'E'
    if (value > 100 && value <= 170) return 'SE'
    if (value > 170 && value <= 190) return 'S'
    if (value > 190 && value <= 260) return 'SW'
    if (value > 260 && value <= 280) return 'W'
    if (value > 280 && value <= 350) return 'NW'
  }
  return ''
}

export const getUnitDx = (current: number) => {
  let unitDx = 1
  if (current < 10) {
    unitDx += 0.2
  } else if (current < 100) {
    unitDx += 0.3
  } else if (current >= 100) {
    unitDx += 0.4
  }
  return unitDx
}
